import { render, staticRenderFns } from "./extrato-habilitacao-juridica.vue?vue&type=template&id=54512d52&scoped=true"
import script from "./extrato-habilitacao-juridica.vue?vue&type=script&lang=js"
export * from "./extrato-habilitacao-juridica.vue?vue&type=script&lang=js"
import style0 from "./extrato-habilitacao-juridica.vue?vue&type=style&index=0&id=54512d52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54512d52",
  null
  
)

export default component.exports